<script>
    export let variant;
</script>

<div class="{variant} contact-section">
    <a href="https://www.linkedin.com/in/osamaelhariri/">
        <div class="contact-circle secondary-contact-color social-circle" title="LinkedIn">
            <i class="fab fa-linkedin fa-2x" />
            <div class="title-text">LinkedIn</div>
        </div>
    </a>

    <a href="https://github.com/OsamaElHariri">
        <div class="contact-circle primary-contact-color code-circle" title="GitHub">
            <i class="fab fa-github fa-2x" />
            <div class="title-text">GitHub</div>
        </div>
    </a>

    <a href="mailto:osama.hariri.dev@gmail.com">
        <div class="contact-circle secondary-contact-color mail-circle" title="Email">
            <i class="fas fa-envelope fa-2x" />
            <div class="title-text">Email</div>
        </div>
    </a>

    <a href="https://blog.osamathe.dev/">
        <div class="contact-circle primary-contact-color mail-circle" title="Blog">
            <i class="fas fa-pen-nib fa-2x" />
            <div class="title-text">Blog</div>
        </div>
    </a>
</div>

<style>
    .contact-section {
        position: relative;
        width: 100%;

        display: flex;
        align-items: baseline;
        justify-content: space-around;
        flex-wrap: wrap;
    }

    .contact-section a {
        margin: 12px;
        text-decoration: none;
    }

    .contact-circle {
        position: relative;
        border-radius: 100%;

        width: 160px;
        height: 160px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        cursor: pointer;

        color: #fffbf5;
    }

    .primary-contact-color {
        background-color: #db2955;
    }

    .secondary-contact-color {
        background-color: #499167;
    }

    .contact-circle:hover {
        animation: bounce 0.4s ease-out forwards;
    }

    .contact-circle div {
        padding-top: 12px;
    }

    .contact-section.tiny .contact-circle {
        width: 60px;
        height: 60px;
    }

    .contact-section.tiny .title-text {
        display: none;
    }
</style>
